module.exports = __webpack_public_path__ + "media/src/images/mails/badge_grade_c-45a5bdfb8801b540d31d8676ecf34d06.png";